import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import BaseComponent from '../BaseComponent';

const NAME = 'MediaCarousel';

const DATA_KEY = 'lta.mediacarousel';
const EVENT_KEY = `.${DATA_KEY}`;
const DATA_API_KEY = '.data-api';

const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;
const SELECTOR_DATA_TOGGLE = '[data-lta-mediacarousel]';

class MediaCarousel extends BaseComponent {
	// eslint-disable-next-line unicorn/no-null
	constructor(element = null) {
		super(element);

		this.componentWrapper_ = element;
		this.swiperState_ = {
			previousSlide: {
				type: undefined,
				videoPlayerComponent: undefined
			}
		};
		this.swiperInstance = undefined;
		this.Swiper = undefined;
		this.Navigation = undefined;
		this.Pagination = undefined;
		this.EffectCoverflow = undefined;

		if (this.componentWrapper_) {
			import('swiper').then(({ Swiper, Navigation, Pagination, EffectCoverflow }) => {
				this.Swiper = Swiper;
				this.Navigation = Navigation;
				this.Pagination = Pagination;
				this.EffectCoverflow = EffectCoverflow;

				this.initMediaCarousel(SelectorEngine.findOne('.swiper', this.componentWrapper_));

				return Swiper;
			}).catch((error) => {
				// eslint-disable-next-line no-console
				console.error(error);
			});
		}
	}

	static get NAME() {
		return NAME;
	}

	onSlideChange_(swiper) {
		// Trigger different actions based on previous slide type.
		switch (this.swiperState_.previousSlide.type) {
			case 'video':
				this.onVideoPreviousSlide_();
				break;
			default:
				break;
		}

		// If current slide is type video set the swiper state with the right slide type.
		const videoSlideElement = SelectorEngine.findOne(`.swiper-slide-active[data-is-video]`, swiper.$wrapperEl[0]);

		if (videoSlideElement) {
			const videoPlayerComponent = SelectorEngine.findOne('lite-video', videoSlideElement);

			this.swiperState_.previousSlide.type = 'video';
			this.swiperState_.previousSlide.videoPlayerComponent = videoPlayerComponent;

			return;
		}

		// If the current slide is not type video reset to default.
		this.swiperState_.previousSlide.type = 'image';
		this.swiperState_.previousSlide.videoPlayerComponent = undefined;
	}

	onVideoPreviousSlide_() {
		const myEvent = new CustomEvent('lta-litevideo-event', {
			bubbles: false,
			detail: {
				command: 'pause',
			}
		});

		this.swiperState_.previousSlide.videoPlayerComponent.dispatchEvent(myEvent);
	}

	initMediaCarousel(swiperElement) {
		const count = swiperElement.querySelector('.swiper-wrapper').children.length;
		this.swiperInstance = new this.Swiper(swiperElement, {
			modules: [this.Navigation, this.Pagination, this.EffectCoverflow],
			slidesPerView: 'auto',
			centeredSlides: true,
			effect: 'fade',
			coverflowEffect: {
				depth: 200,
				modifier: 1,
				rotate: 0,
				slideShadows: true,
				stretch: -50
			},
			navigation: {
				prevEl: '.lta-media-carousel__prev',
				nextEl: '.lta-media-carousel__next'
			},
			watchSlidesProgress: true,
			grabCursor: true,
			observer: true,
			loop: true,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet(index, className) {
					return `<button class="${className} ${className}${index}" aria-label="Slide ${index+1} of ${count}"></button>`;
				},
			},
			a11y: {
				prevSlideMessage: 'Previous slide',
				nextSlideMessage: 'Next slide',
				paginationBulletMessage: 'Go to slide {{index}}',
			},
		});

		this.swiperInstance.on('slideChangeTransitionEnd', this.onSlideChange_.bind(this));
	}
}

/**
 * Data Api implementation
 */
EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function (event) {
	event.preventDefault();

	MediaCarousel.getInstance(this) || new MediaCarousel(this);
});

export default MediaCarousel;
